import { Component, Input } from '@angular/core';
import { Params, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-page-wrapper',
  imports: [RouterModule, CommonModule],
  templateUrl: './page-wrapper.component.html',
  styleUrl: './page-wrapper.component.scss',
})
export class PageWrapperComponent {
  @Input() title!: string;
  @Input() subtitle!: string;
  @Input() goBackUrl?: string | any[];
  @Input() goBackQueryParams?: Params;
}
